import {Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef} from '@angular/core';
import {Location} from '@angular/common';
import {LocalStorageService} from 'ngx-webstorage';

import { DateTimeService } from '../../../services/date-time.service';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-calendar',
  styleUrls: ['./calendar.component.scss'],
  templateUrl: './calendar.component.html'
})
export class CalendarComponent implements OnInit, OnDestroy {

  public days = [];
  public monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  public daysName = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  public cart = [];
  public sub;
  public id;
  public startPoint = 0;
  public endPoint = 7;
  public activeId = 3;
  public nextId = 0;
  public showNoDays = 7;
  public holidaylist = [];
  editOrderAddingAnotherItem = false;
  pastOrderAgain = true;
  // for windows size
  public divWidth;
  showBasicCalendar = true;
  addAnimatedClass = true;

  @ViewChild('calendarParentDiv') parentDiv: ElementRef;

  @HostListener('window:resize') onResize() {
    if (this.parentDiv) {
      this.divWidth = this.parentDiv.nativeElement.clientWidth;
    }
    this.reSIzeCalander();
  }

  private markHoliday() {
    this.days.forEach((aDay) => {
      this.holidaylist.forEach((aHoliday) => {
        if (aDay.fullDate === aHoliday) {
          aDay.isHoliday = true;
        }
      });
    });
  }

  private selectedDay() {
    for (let i = 0; i < this.days.length; i++) {
      const aDay = this.days[i];
      if (aDay.dayName !== 'Sunday' && !aDay.isHoliday) {
        // tslint:disable-next-line:max-line-length
        // if (this.localSt.retrieve('itemDetailEndStartDate') && Math.round(new Date(this.localSt.retrieve('itemDetailEndStartDate').startDate).getTime() / 1000) > Math.round(new Date(this.days[0].fullDate).getTime() / 1000)) {
        //   this.days.forEach((itemStartDate) => {
        //     if (itemStartDate.fullDate === this.localSt.retrieve('itemDetailEndStartDate').startDate) {
        //       this.selectedDateClick(itemStartDate);
        //     }
        //   });
        // } else
        if (!this.localSt.retrieve('myCartSelectedDate') || this.localSt.retrieve('myCartSelectedDate') === aDay.fullDate) {
          this.selectedDateClick(aDay);
        } else {
          this.days.forEach((day, index) => {
            if (day.fullDate === this.localSt.retrieve('myCartSelectedDate')) {
              if (index > 30 - this.showNoDays) {
                this.startPoint = 30 - this.showNoDays;
                this.endPoint = this.startPoint + this.showNoDays;
              } else {
                this.startPoint = index;
                this.endPoint = index + this.showNoDays;
              }
              this.selectedDateClick(day);
            }
          });
        }
        this.localSt.store('currentDate', aDay.fullDate);
        aDay.isHoliday = false;
        break;
      }
    }
  }

  /**
   * TypeScript public modifiers
   */
  constructor(private location: Location,
              private localSt: LocalStorageService,
              public dateTimeService: DateTimeService,
              public commonService: CommonService) {
  }

  public reSIzeCalander() {
    if (this.divWidth <= 414) {
      this.showNoDays = 4;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else if (this.divWidth >= 414 && this.divWidth < 768) {
      this.showNoDays = 5;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else if (this.divWidth >= 768 && this.divWidth < 1024) {
      this.showNoDays = 5;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else if (this.divWidth >= 1024 && this.divWidth < 1366) {
      this.showNoDays = 7;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else if (this.divWidth >= 1366 && this.divWidth < 1600) {
      this.showNoDays = 7;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else if (this.divWidth >= 1600 && this.divWidth < 2900) {
      this.showNoDays = 7;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else {
      this.showNoDays = 10;
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    }
  }

  public isHidden() {
    // console.log(this.location);
    // let path = this.location.path();
    return true;
    // return !(this.showCalenderInPages.indexOf(path) > -1);
  }


  public ngOnInit() {
    const currentDate = new Date();
    let skipDays =  4;
    // if time is after 12 pm skip today
    if (currentDate.getHours() >= 12) { skipDays = 5; }
    this.commonService.getConfig().subscribe((params) => {
      this.holidaylist = params.data.zf_holidays;
      this.localSt.store('holidaysList', this.holidaylist);
      this.createDaysForCalander(this.skipHolidaysInNextDays(skipDays));
      this.markHoliday();
      this.selectedDay();
    }, error => {
      this.createDaysForCalander(this.skipHolidaysInNextDays(skipDays));
      this.markHoliday();
      this.selectedDay();
    });

    // wait a tick to avoid one-time devMode
    // unidirectional-data-flow-violation error
    setTimeout(_ => {
      this.divWidth = this.parentDiv.nativeElement.clientWidth;
      this.reSIzeCalander();
    });

    this.localSt.observe('myCartSelectedDate').subscribe((date) => {
      if (date) {
        this.days.forEach((day, index) => {
          if (day.fullDate === date) {
            if (index > 30 - this.showNoDays) {
              this.startPoint = 30 - this.showNoDays;
              this.endPoint = this.startPoint + this.showNoDays;
            } else {
              this.startPoint = index;
              this.endPoint = index + this.showNoDays;
            }
            this.selectedDateClick(day);
          }
        });
      }
    });

    // tslint:disable-next-line:max-line-length
    this.localSt.retrieve('editOrderAddingAnotherItem') ? this.editOrderAddingAnotherItem = this.localSt.retrieve('editOrderAddingAnotherItem') : this.editOrderAddingAnotherItem = false;
    // tslint:disable-next-line:max-line-length
    this.localSt.retrieve('pastOrderAgain') ? this.pastOrderAgain = this.localSt.retrieve('pastOrderAgain') : this.pastOrderAgain = true;
    setTimeout(_ => {
      this.localSt.observe('editOrderAddingAnotherItem').subscribe((editOrderAddingAnotherItem) => {
        this.editOrderAddingAnotherItem = !!editOrderAddingAnotherItem;
      });
      this.localSt.observe('pastOrderAgain').subscribe((pastOrderAgain) => {
        if (pastOrderAgain) {
          this.pastOrderAgain = true;
        }
      });
    });

    // setTimeout(_ => {
    //   this.localSt.observe('itemDetailEndStartDate').subscribe((itemDetailEndStartDate) => {
    //     if (itemDetailEndStartDate) {
    //       this.days.forEach((aDay) => {
    //         aDay.disable = false;
    //       });
    //       // tslint:disable-next-line:max-line-length
    //       if (Math.round(new Date(itemDetailEndStartDate.endDate).getTime() / 1000) < Math.round(new Date(this.days[this.days.length - 1].fullDate).getTime() / 1000) && itemDetailEndStartDate.endDate !== null) {
    //         this.days.forEach((aDay, index) => {
    //           if (aDay.fullDate === itemDetailEndStartDate.endDate) {
    //             for (let i = index + 1; i <  this.days.length; i++) {
    //               const day = this.days[i];
    //               day.disable = true;
    //             }
    //           }
    //         });
    //       }
    //       // tslint:disable-next-line:max-line-length
    //       if (Math.round(new Date(itemDetailEndStartDate.startDate).getTime() / 1000) > Math.round(new Date(this.days[0].fullDate).getTime() / 1000)) {
    //         this.days.forEach((aDay, index) => {
    //           if (aDay.fullDate === itemDetailEndStartDate.startDate) {
    //             for (let i = 0; i < index; i++) {
    //               const day = this.days[i];
    //               day.disable = true;
    //             }
    //           }
    //         });
    //       }
    //     } else {
    //       this.days.forEach((aDay) => {
    //         aDay.disable = false;
    //       });
    //     }
    //   });
    // });
  }


  skipHolidaysInNextDays(skipDays) {
    const today =  new Date();
    for (let i = 1; i < skipDays; i++) {
      const tomorrow = this.dateTimeService.addDays(today, i);
      if (this.holidaylist.indexOf(this.dateTimeService.formatDate(tomorrow)) > -1 || tomorrow.getDay() === 0) {
        skipDays++;
      }
    }
    return skipDays;
  }

  createDaysForCalander(skipDays) {
    const today = this.dateTimeService.addDays(new Date(), skipDays);
    for (let i = 0; i < 30; i++) {
      const tomorrow = this.dateTimeService.addDays(today, i);
      this.days.push({
        dayName: this.daysName[tomorrow.getDay()],
        monthName: this.monthNames[tomorrow.getMonth()],
        dayNumber: tomorrow.getDate(),
        fullDate: this.dateTimeService.formatDate(tomorrow),
        arrIndex: i,
        state: 'active',
        isSelected: false,
        isHoliday: false
      });
    }
  }

  changeDaysStatusActive() {
    this.days.forEach((day, i) => {
      day.state = 'inactive';
      if (i >= this.startPoint && i <= this.endPoint) {
        day.state = 'active';
      }
    });
  }

  public previousDate() {
    if (this.startPoint < this.showNoDays) {
      this.startPoint = 0;
      this.endPoint = this.showNoDays;
    } else {
      this.startPoint -= this.showNoDays;
      this.endPoint -= this.showNoDays;
    }
    this.changeDaysStatusActive();
  }

  public nextDate() {
    if (this.endPoint > 30 - this.showNoDays) {
      this.startPoint = 30 - this.showNoDays;
      this.endPoint = 30;
    } else {
      this.startPoint += this.showNoDays;
      this.endPoint += this.showNoDays;
    }
    this.changeDaysStatusActive();
  }

  public ngOnDestroy() {
    this.localSt.clear('myCartSelectedDate');
  }

  selectedDateClick(item) {
    this.days.forEach((day, i) => {
      day.isSelected = false;
    });
    this.localSt.store('selectedDate', item);
    item.isSelected = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/calendar/calendar.component.ts